import {
  BanknotesIcon,
  BuildingOfficeIcon,
  CurrencyDollarIcon,
  DocumentTextIcon,
  HomeIcon,
  PencilSquareIcon,
  QuestionMarkCircleIcon,
  RocketLaunchIcon,
  ShoppingBagIcon,
  ShoppingCartIcon,
  UsersIcon,
  KeyIcon,
  ClipboardDocumentListIcon,
} from '@heroicons/react/24/solid';

import { VENDORS_PORTAL_API_URL } from 'src/constants/urls';
import { ENABLE_COUPONS_FEATURE } from 'src/modules/Price/constants/feature_flags';
import { ENABLE_NEW_ORDERS_PAGE } from 'src/modules/OrderManagement/utils/featureFlags';

const iconProps = {
  height: '1.2em',
  color: '#b2c4c7',
};

const featureFlagRedirectToVPBrandEdit =
  process.env
    .REACT_APP_FEATURE_FLAG_REDIRECT_TO_VENDORS_PORTAL_BRAND_EDIT_PAGE ===
  'true';

const ENABLE_REGISTRATION_DATA_FEATURE =
  process.env.REACT_APP_ENABLE_REGISTRATION_DATA_FEATURE === 'true';

const ENABLE_MIGRATED_PRODUCTS_LIST =
  process.env.REACT_APP_ENABLE_MIGRATED_PRODUCTS_LIST === 'true';

export const getMenuLinks = quotationFeatureFlag => [
  {
    name: 'Home',
    externalLink: true,
    link: VENDORS_PORTAL_API_URL,
    icon: <HomeIcon {...iconProps} />,
  },
  {
    name: 'Acelerar vendas',
    link: '/indicar',
    icon: <RocketLaunchIcon {...iconProps} />,
  },
  {
    name: 'Clientes',
    externalLink: true,
    link: `${VENDORS_PORTAL_API_URL}/clientes`,
    icon: <UsersIcon {...iconProps} />,
  },
  {
    name: 'Extrato financeiro',
    link: '/extrato',
    icon: <DocumentTextIcon {...iconProps} />,
  },
  {
    name: 'Pedidos',
    externalLink: ENABLE_NEW_ORDERS_PAGE,
    link: ENABLE_NEW_ORDERS_PAGE
      ? `${VENDORS_PORTAL_API_URL}/pedidos`
      : '/pedido',
    icon: <ShoppingCartIcon {...iconProps} />,
  },
  {
    name: 'Promoções',
    link: '/promocoes',
    icon: <CurrencyDollarIcon {...iconProps} />,
  },
  ...(ENABLE_COUPONS_FEATURE
    ? [
        {
          name: 'Cupons',
          externalLink: true,
          link: `${VENDORS_PORTAL_API_URL}/descontos/cupons`,
          icon: <BanknotesIcon {...iconProps} />,
        },
      ]
    : []),
  ...(quotationFeatureFlag
    ? [
        {
          name: 'Orçamentos',
          externalLink: true,
          link: `${VENDORS_PORTAL_API_URL}/orcamentos`,
          icon: <ClipboardDocumentListIcon {...iconProps} />,
        },
      ]
    : []),
  {
    name: 'Produtos',
    externalLink: ENABLE_MIGRATED_PRODUCTS_LIST,
    link: ENABLE_MIGRATED_PRODUCTS_LIST
      ? `${VENDORS_PORTAL_API_URL}/produto`
      : '/product',
    icon: <ShoppingBagIcon {...iconProps} />,
  },
  {
    name: 'Editar loja',
    externalLink: true,
    link: featureFlagRedirectToVPBrandEdit
      ? `${process.env.REACT_APP_VENDORS_PORTAL_API_URL}/marca/editar`
      : '/legacy-loja',
    icon: <PencilSquareIcon {...iconProps} />,
  },
  ...(ENABLE_REGISTRATION_DATA_FEATURE
    ? [
        {
          name: 'Dados cadastrais',
          externalLink: true,
          link: `${VENDORS_PORTAL_API_URL}/dados-cadastrais`,
          icon: <BuildingOfficeIcon {...iconProps} />,
        },
      ]
    : []),
  {
    name: 'Integrações',
    externalLink: true,
    link: `${VENDORS_PORTAL_API_URL}/integracoes`,
    icon: <KeyIcon {...iconProps} />,
  },
  {
    icon: <QuestionMarkCircleIcon {...iconProps} />,
    name: 'Ajuda',
    externalLink: true,
    attrs: {
      target: '_blank',
    },
    link: process.env.REACT_APP_VENDOR_SUPPORT_FAQ,
  },
];
